import React, { useEffect, useRef, useState } from "react";
import { HomeHeader } from "../../../components/headers/HomeHeader"; // <- adjust if needed

const HOME_HEADER_HEIGHT = 79; // match your HomeHeader height

export const ReserveAdequacyMonitoring = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const tagRef = useRef(null);
  const dropdownRef = useRef(null);
  const year = new Date().getFullYear();

  // Close dropdown when clicking outside
  useEffect(() => {
    const onClickAway = (e) => {
      if (!menuOpen) return;
      const t = e.target;
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(t) &&
        tagRef.current &&
        !tagRef.current.contains(t)
      ) {
        setMenuOpen(false);
      }
    };
    window.addEventListener("click", onClickAway);
    return () => window.removeEventListener("click", onClickAway);
  }, [menuOpen]);

  return (
    <div>
      <HomeHeader headerColor="#0D131E" textColor="#ffffff" />

      {/* Scoped styles (prefixed with .ram- to avoid leaking) */}
      <style>{`
        li {
          padding-top:10px;
          padding-bottom:0px;
        }

        .ram-root {
          --bg: #0a0c10;
          --panel: #0f131a;
          --panel-2: #121722;
          --text: #e6e9ef;
          --muted: #a7b0c0;
          --brand: #0b5cff;
          --brand-2: #8ab4ff;
          --ok: #1fbf75;
          --warn: #ffd166;
          --danger: #ff5d5d;
          --card-radius: 18px;
          --shadow: 0 10px 30px rgba(0,0,0,.35);
          --maxw: 1100px;
          --offset: ${HOME_HEADER_HEIGHT}px;

          color: var(--text);
          background:
            radial-gradient(1200px 800px at 10% -10%, rgba(11,92,255,.15), transparent 60%),
            radial-gradient(1200px 800px at 110% 10%, rgba(138,180,255,.1), transparent 60%),
            var(--bg);
          line-height: 1.55;
          font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji";
          letter-spacing: normal; /* avoid tight tracking */
          text-align: left;       /* do not inherit center from parents */
        }

        .ram-container { max-width: var(--maxw); margin: 0 auto; padding: 24px; }

        /* Page header (sticks below HomeHeader) */
        .ram-header {
          position: sticky;
          top: var(--offset);
          z-index: 50;
          backdrop-filter: saturate(140%) blur(10px);
          background: linear-gradient(180deg, rgba(10,12,16,.9), rgba(10,12,16,.6));
          border-bottom: 1px solid rgba(255,255,255,.06);
        }
        .ram-nav { display:flex; align-items:center; justify-content:space-between; gap:16px; }
        .ram-logo { display:flex; align-items:center; gap:12px; text-decoration:none; color:var(--text); }
        .ram-mark { width:28px; height:28px; display:grid; place-items:center; border-radius:8px; background:linear-gradient(135deg, var(--brand), #2b90ff); box-shadow: var(--shadow); }
        .ram-word { font-weight:700; letter-spacing:.2px; }

        .ram-cta { display:flex; gap:10px; }
        .ram-btn {
          --padx: 14px; --pady: 10px;
          padding: var(--pady) var(--padx);
          border-radius: 999px;
          border: 1px solid rgba(255,255,255,.12);
          color: var(--text);
          text-decoration: none;
          font-weight: 600; font-size: 14px;
          transition: transform .06s ease, background .2s ease, border-color .2s ease;
        }
        .ram-btn:hover { transform: translateY(-1px); }
        .ram-btn.primary { background: linear-gradient(135deg, var(--brand), #2b90ff); border-color: transparent; }
        .ram-btn.ghost { background: rgba(255,255,255,.03); }

        .ram-hero { padding: 56px 0 26px; position: relative; }
        .ram-hero h1 {
          font-size: clamp(34px, 3.8vw, 48px);
          line-height: 1.15;
          margin: 0 0 16px;
          letter-spacing: .3px;
          word-spacing: .5px;
        }
        .ram-hero p { color: var(--muted); font-size: clamp(16px, 1.7vw, 18px); max-width: 880px; }
        .ram-tag {
          display:inline-flex; align-items:center; gap:8px; padding:6px 12px;
          border-radius:999px; background: rgba(11,92,255,.12); color:#cfe0ff;
          border:1px solid rgba(138,180,255,.25); font-weight:600; font-size:13px; cursor:pointer;
        }

        .ram-grid { display:grid; gap:18px; }
        .ram-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }
        .ram-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
        .ram-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
        @media (max-width: 1000px) { .ram-cols-4 { grid-template-columns: 1fr 1fr; } }
        @media (max-width: 700px) { .ram-cols-4, .ram-cols-3, .ram-cols-2 { grid-template-columns: 1fr; } }

        .ram-card { background: linear-gradient(180deg, var(--panel), var(--panel-2)); border:1px solid rgba(255,255,255,.06); border-radius: var(--card-radius); box-shadow: var(--shadow); padding: 20px 18px; }
        .ram-card h3 { margin: 0 0 8px; font-size: 18px; }
        .ram-card p { margin: 0; color: var(--muted); }

        .ram-kv { display:flex; gap:12px; align-items:flex-start; padding: 14px 0; border-top: 1px dashed rgba(255,255,255,.08); }
        .ram-kv:first-child { border-top: 0; }
        .ram-k { flex: 0 0 160px; color:#cfe0ff; font-weight:700; text-transform:uppercase; letter-spacing:.6px; font-size:12px; }
        .ram-v { flex: 1; color: var(--text); }

        .ram-badges { display:flex; gap:8px; flex-wrap:wrap; }
        .ram-badge { display:inline-flex; align-items:center; gap:8px; padding:8px 12px; border-radius:12px; background: rgba(255,255,255,.04); border:1px solid rgba(255,255,255,.08); font-weight:600; color: var(--text); }

        .ram-section { margin: 30px 0; }
        .ram-section h2 { font-size:22px; margin:0 0 8px; }
        .ram-muted { color: var(--muted); }

        .ram-headline { display:flex; align-items:center; gap:12px; margin:28px 0 10px; }
        .ram-rule { height:1px; background: linear-gradient(90deg, rgba(255,255,255,0), rgba(255,255,255,.2), rgba(255,255,255,0)); flex:1; }

        .ram-callout { border-left:3px solid var(--brand); background: rgba(11,92,255,.08); padding:14px 16px; border-radius:10px; }

        .ram-metrics { display:grid; grid-template-columns: repeat(4, minmax(0,1fr)); gap:12px; margin-top:12px; }
        .ram-metric { text-align:center; padding:16px; border-radius:14px; background: rgba(255,255,255,.04); border:1px solid rgba(255,255,255,.08); }
        .ram-metric h4 { margin:0 0 4px; font-size:20px; }
        .ram-metric p { margin:0; color: var(--muted); font-size:14px; }
        @media (max-width: 1000px) { .ram-metrics { grid-template-columns: 1fr 1fr; } }
        @media (max-width: 700px) { .ram-metrics { grid-template-columns: 1fr; } }

        .ram-footer { margin: 40px 0 20px; color: var(--muted); font-size: 13px; text-align:center; }

        /* Dropdown */
        .ram-menu {
          position:absolute;
          background-color:#0f131a;
          min-width:260px;
          z-index:10;
          border-radius:10px;
          box-shadow: var(--shadow);
          border:1px solid rgba(255,255,255,.12);
          margin-top:8px;
        }
        .ram-menu a { color: var(--text); padding:12px; text-decoration:none; display:block; }
        .ram-menu a:hover { background-color: var(--brand-2); }

        @media print {
          .ram-header { display:none; }
          .ram-root { background:#fff; color:#111; }
          .ram-card { background:#fff; border-color:#ddd; box-shadow:none; }
          .ram-hero .ram-tag { background:#e9f1ff; color:#0b5cff; border-color:#c9ddff; }
        }
      `}</style>

      <div className="ram-root">
        {/* Page header (under HomeHeader) */}
        <header className="ram-header">
          <div className="ram-container ram-nav">
            <a
              className="ram-logo"
              href="#top"
              aria-label="Charlee.ai — Reserve Adequacy Monitoring"
            >
              <span className="ram-mark" aria-hidden="true">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                >
                  <path
                    d="M12 2l2.2 5.7L20 10l-5.8 2.3L12 18l-2.2-5.7L4 10l5.8-2.3L12 2z"
                    fill="white"
                    opacity=".9"
                  />
                </svg>
              </span>
              <span className="ram-word">Charlee.ai</span>
            </a>
            <div className="ram-cta">
              <a className="ram-btn ghost" href="#value">
                Value
              </a>
              <a className="ram-btn ghost" href="#financial-impact">
                Financial Impact
              </a>
              <a className="ram-btn primary" href="#product">
                Product
              </a>
            </div>
          </div>
        </header>

        <main className="ram-container" style={{ paddingTop: "70px" }}>
          <section className="ram-hero">
            {/* Dropdown trigger */}
            <span
              ref={tagRef}
              className="ram-tag"
              onClick={() => setMenuOpen((v) => !v)}
              aria-haspopup="true"
              aria-expanded={menuOpen}
              role="button"
            >
              Use Case 3 · Reserve Adequacy Monitoring (Incurred Below
              Prediction) <span aria-hidden="true">▼</span>
            </span>

            {/* Dropdown menu (SEO-friendly anchors) */}
            <div
              ref={dropdownRef}
              className="ram-menu"
              style={{ display: menuOpen ? "block" : "none" }}
            >
              <a href="/usecase/large-loss-alerts">
                Use Case 1 · Large Loss Alerts
              </a>
              <a href="/usecase/early-severity-signal-detection">
                Use Case 2 · Early Severity Signal Detection
              </a>
              <a href="/usecase/reserve-adequacy-monitoring">
                Use Case 3 · Reserve Adequacy Monitoring (Incurred Below
                Prediction)
              </a>
              <a href="/usecase/high-severity-potential-claims">
                Use Case 4 · High Severity Potential Claims
              </a>
              <a href="/usecase/proactive-severity-litigation-intelligence">
                Use Case 5 · Proactive Severity & Litigation Intelligence
              </a>
              <a href="/usecase/intelligent-claims-document-summarization">
                Use Case 6 · Intelligent Claims Document Summarization
              </a>
            </div>

            <h1 style={{ fontWeight: "bold" }}>
              Stay in Reserve Range <br />— Detect Mismatches Before They Become
              Leakage
            </h1>
            <p>
              For claims executives, managers, supervisors, and actuaries,
              reserve adequacy isn't just a financial metric—it’s the backbone
              of regulatory compliance, efficient claims management, and
              accurate actuarial analysis. But rising claim severity,
              unpredictable litigation, and the loss of tribal knowledge from a
              retiring workforce are creating serious gaps in reserving
              accuracy. Traditional spreadsheet-driven audits can’t spot these
              gaps in time.
            </p>
            <br />
            <p className="ram-muted">
              That’s where <strong>4SeeCharlee</strong> steps in. By applying
              pre-trained reserving patterns learned from over 55 million
              claims—and continuously refined across carriers—Charlee’s
              NLP-powered AI flags reserve mismatches in real time. It
              highlights under- and over-reserved open claims by identifying
              patterns learned across carriers, empowering teams to take
              proactive action on these inconsistencies before small gaps become
              financial blind spots.
            </p>
          </section>

          <section className="ram-grid ram-cols-4">
            <div className="ram-card">
              <h3 style={{ fontWeight: "bold" }}>Role</h3>
              <p>
                Claims Executives, Claims Managers, Claims Supervisors,
                Actuaries
              </p>
            </div>
            <div className="ram-card">
              <h3 style={{ fontWeight: "bold" }}>Job at Hand</h3>
              <p>Maintain accurate reserves and financial reporting</p>
            </div>
            <div className="ram-card">
              <h3 style={{ fontWeight: "bold" }}>Trigger</h3>
              <p>Monthly reserve adequacy audit flagged inconsistencies</p>
            </div>
            <div className="ram-card">
              <h3 style={{ fontWeight: "bold" }}>Pain Point</h3>
              <p>
                Claims incurring higher than expected, with potential reserve
                deficiencies
              </p>
            </div>
          </section>

          <section className="ram-grid ram-cols-2 ram-section">
            <div className="ram-card">
              <h3 style={{ fontWeight: "bold" }}>Before Charlee</h3>
              <p>
                Spreadsheet-driven manual review of open claims for reserve
                adjustments, IBNR irregularities, and reserving/profitability
                issues.
              </p>
            </div>
            <div className="ram-card">
              <h3 id="product" style={{ fontWeight: "bold" }}>
                With Charlee
              </h3>
              <p>
                AI continuously monitors reserves vs. predicted incurred, flags
                under- and over-reserved risks, and surfaces high-impact claims
                for review.
              </p>
            </div>
          </section>

          <section className="ram-section">
            <div className="ram-grid ram-cols-3">
              <div className="ram-card">
                <h3 style={{ fontWeight: "bold" }}>Product Used</h3>
                <div className="ram-badges">
                  <span className="ram-badge">🔎 4SeeCharlee</span>
                </div>
              </div>
              <div className="ram-card">
                <h3 style={{ fontWeight: "bold" }}>LOBs</h3>
                <div className="ram-badges">
                  <span className="ram-badge">All</span>
                </div>
              </div>
              <div className="ram-card" id="value">
                <h3 style={{ fontWeight: "bold" }}>Area</h3>
                <div className="ram-badges">
                  <span className="ram-badge">Claims</span>
                  <span className="ram-badge">Reserves</span>
                </div>
              </div>
            </div>
          </section>

          <section className="ram-section">
            <div className="ram-headline">
              <h2 style={{ margin: 0, fontWeight: "bold" }}>
                Value Proposition
              </h2>
              <div className="ram-rule" />
            </div>
            <div className="ram-card">
              <ul style={{ listStyleType: "disc", paddingLeft: "50px" }}>
                <li>
                  Early reserve adequacy assessment benefits both present and
                  future processes.
                </li>
                <li>
                  Claims can be reviewed sooner based on claim age, potentially
                  accelerating reserve decisions.
                </li>
                <li>
                  Early reviews ensure timely data collection, improving
                  outcomes and reducing litigation.
                </li>
                <li id="financial-impact">
                  Increased productivity and precision in financial reporting
                  and reserve setting.
                </li>
                <li>
                  Insights can be used to train staff and improve long-term
                  reserve practices.
                </li>
              </ul>
            </div>
          </section>

          <section className="ram-section">
            <div className="ram-headline">
              <h2 style={{ margin: 0, fontWeight: "bold" }}>
                Financial Impact
              </h2>
              <div className="ram-rule" />
            </div>
            <div className="ram-card">
              <p className="ram-muted">Inaccurate reserves can lead to:</p>
              <ul style={{ listStyleType: "disc", paddingLeft: "50px" }}>
                <li>
                  Regulatory scrutiny, particularly when under-reserving forces
                  late reserve strengthening
                </li>
                <li>
                  Over-reserving, tying up capital and inflating liability
                  estimates
                </li>
                <li>
                  Late adjustments, distorting financial reports and
                  complicating reinsurance/actuarial operations
                </li>
              </ul>
              <div className="ram-callout" style={{ marginTop: 12 }}>
                <strong>Charlee delivers:</strong>
                <ul style={{ listStyleType: "disc", paddingLeft: "50px" }}>
                  <li>
                    $5K–$15K estimated savings per under-reserved claim due to
                    early corrections
                  </li>
                  <li>
                    Reduced capital drag by optimizing over-reserved claims
                  </li>
                  <li>Avoidance of reserve leakage and surprise adjustments</li>
                  <li>
                    Improved quarter/year-end closing accuracy and stability
                  </li>
                  <li>
                    Millions in reported reserve optimization gains from
                    real-world deployments
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <section className="ram-section">
            <div className="ram-headline">
              <h2 style={{ margin: 0, fontWeight: "bold" }}>Results</h2>
              <div className="ram-rule" />
            </div>
            <div className="ram-card">
              <div className="ram-metrics">
                <div
                  className="ram-metric"
                  aria-label="Reserve accuracy improvement"
                >
                  <h4>📈 18%</h4>
                  <p>improvement in reserve accuracy</p>
                </div>
                <div
                  className="ram-metric"
                  aria-label="Late adjustments reduction"
                >
                  <h4>✅ 30%</h4>
                  <p>reduction in late reserve adjustments</p>
                </div>
                <div className="ram-metric" aria-label="Customer quote">
                  <h4>💬</h4>
                  <p>
                    “Now our actuaries, supervisors, and adjusters are finally
                    aligned.”
                  </p>
                </div>
                <div className="ram-metric" aria-label="Time to value">
                  <h4>⏱️ 2 weeks</h4>
                  <p>Dashboards ready; rapid time-to-value</p>
                </div>
              </div>
            </div>
          </section>

          <section className="ram-section">
            <div className="ram-headline">
              <h2 style={{ margin: 0, fontWeight: "bold" }}>Why It Matters</h2>
              <div className="ram-rule" />
            </div>
            <div className="ram-card">
              <p>
                Early detection of reserve mismatches prevents leakage, reduces
                volatility in financial reporting, and improves capital
                efficiency.
              </p>
            </div>
          </section>

          <footer className="ram-footer">
            © {year} Charlee.ai — Use Case 3: Reserve Adequacy Monitoring
          </footer>
        </main>
      </div>
    </div>
  );
};
